import { Injectable } from '@angular/core';
import { SERVICE_PREFIX } from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

import { HttpService } from '../../core/http-service/http.service';
import { IImageUploadResponse } from '../../interfaces/rich-text-editor-service.interface';

@Injectable({
  providedIn: 'root',
})
export class SharedRichTextEditorService {
  constructor(private readonly _apiService: HttpService) {}

  /**
   * Uploads an image file to the server.
   *
   * @param file - The image file to be uploaded.
   * @returns An Observable that emits the server response.
   */
  public uploadImage(file: File): Observable<IImageUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return this._apiService.post(
      `${SERVICE_PREFIX.PRODUCT_SVC_EXT}/emailTemplates/upload`,
      formData
    );
  }
}
